import React, { useState } from 'react';

function OrdenarProductos({ selectedOrden, setSelectedOrden,setFiltros,donde}) {
  const [isOpen, setIsOpen] = useState(false);

  const options = ['Defecto', 'Relevancia', 'Menor Precio', 'Mayor Precio'];

  const handleOptionClick = (option, index) => {
    setSelectedOrden({ id: index, option: option });
    setIsOpen(false);
    if (donde === "mostratodo") {
      setFiltros((prevFiltros) => ({
        ...prevFiltros,
        orden: index,
      }));
    }
  };

  return (
    <div className='relative flex justify-end text-center items-center h-full w-full'>
      <label className='mr-2 font-bold text-Negro text-xs xl:text-base'>Ordenar por:</label>
      <div className='relative'>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className='w-40 h-10 flex items-center text-center p-3 rounded focus:outline-none'
        >
          <label className='font-bold text-Verde text-xs xl:text-base'>
            {!selectedOrden.option ? options[0] : selectedOrden.option}
          </label>
        </button>
        {isOpen && (
          <ul className='absolute left-0 mt-1 w-full bg-Blanco border border-gray-300 rounded shadow-lg z-50'>
            {options.map((option, index) => (
              <li
                key={index}
                onClick={() => handleOptionClick(option, index)}
                className='px-4 py-2 font-bold hover:bg-GrisClaro hover:text-Verde cursor-pointer text-xs xl:text-base'
              >
                {option}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default OrdenarProductos;
